import { Breadcrumbs, Typography, Stack, TablePagination, Link } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import RefreshButton from "../../../../../common/components/refresh_button";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { Header } from "./components/header";
import { BackButton } from "../../../../../common/components/back_button";
import { useRevisaoListaGerenciarViewModel } from "../../viewModels/revisao_listagerenciar_view_model";
import { GenerateProjetoRevisaoColumnDefinition } from "./columns";
import { useMemo } from "react";

export const Revisao_listagerenciar = () => {
  const viewModel = useRevisaoListaGerenciarViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateProjetoRevisaoColumnDefinition({
      onActionEditar: viewModel.handleEditVisualizar,
    });
  }, [
    viewModel.handleEditVisualizar,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <BackButton onClick={() => window.history.back()} />
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit">
            Projetos
          </Link>
          <Typography className="text-primary-green">Gerenciar Solicitação de Revisão</Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Gerenciar Solicitações de Revisão</h1>
          <RefreshButton onClick={() => viewModel.handleClear()} />
        </div>

        <Header
          ddlCentroCusto={viewModel.ddlCentroCusto}
          ddlProjeto={viewModel.ddlProjeto}
          ddlSolicitante={viewModel.ddlFuncionario}
          idsCentroCusto={viewModel.filters.idsCentroCusto}
          idsProjeto={viewModel.filters.idsProjeto}
          idsSolicitante={viewModel.filters.idsSolicitante}
          statusOptions={viewModel.ddlStatus}
          status={viewModel.filters.status ?? undefined}
          dataDe={viewModel.filters.dataDe}
          dataAte={viewModel.filters.dataAte}
          onCentroCustoChange={viewModel.handleCentroCustoChange}
          onProjetoChange={viewModel.handleProjetoChange}
          onSolicitanteChange={viewModel.handleSolicitanteChange}
          onStatusChange={viewModel.handleStatusChange}
          onDataChange={viewModel.handleDataChange}
          onClearFilters={viewModel.handleClear}
        />

        <Stack spacing={0}>
          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />

          <StyledDataGrid
            tableName="ProjetoRevisao"
            disableColumnMenu={false}
            showToolbar
            disableRowSelectionOnClick
            getRowId={(row: any) => row.idProjetoRevisao}
            columns={columnsDefinition}
            loading={viewModel.loading}
            rows={viewModel.listaRevisao ?? []}
            rowCount={viewModel.pagination.totalItems}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page - 1,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
            pinnedColumns={{
              right: ['idProjetoRevisao'],
            }}
            getRowHeight={() => 'auto'}
          />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />
        </Stack>

      </div>
    </>
  );
};
